module.exports = __webpack_public_path__ + "img/gradient-add.5b47e894.svg";